export default "__VITE_ASSET__DqsGQOh___"